module.exports = __webpack_public_path__ + "static/media/car.ec22a982.glb";